import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PaymentSolutions } from '../components/PaymentSolutions';
import { PaymentMethods } from '../components/PaymentMethods';
interface OverviewPageProps {
  onNavigate?: (pageId: string) => void;
  onSectionChange?: (section: 'documentation' | 'api-reference') => void;
}
export function OverviewPage({
  onNavigate,
  onSectionChange
}: OverviewPageProps) {
  return <>
      <HeroSection onNavigate={onNavigate} onSectionChange={onSectionChange} data-id="element-1813" />
      <div className="max-w-6xl mx-auto px-8 pb-24" data-id="element-1814">
        <PaymentSolutions onNavigate={onNavigate} data-id="element-1815" />
        <PaymentMethods onNavigate={onNavigate} data-id="element-1816" />
      </div>
    </>;
}